import axios from 'axios';
import { Dispatch } from 'redux';
import { ActionType } from '../Actions/ActionTypes';
import { moshaveran } from '../../../../../../config/api';

function fetchMoshaveran() {

    return axios.get(moshaveran)
}

export const actionFetchAllMoshaveran = () => {
    
    return (dispatch: Dispatch) => {
        dispatch({ type: ActionType.ALL_MOSHAVERAN_LOAGING })
        fetchMoshaveran().then((res) => {
            dispatch({ type: ActionType.ALL_MOSHAVERAN_DATA, data: res.data.data })
        }).catch(err => {
            if (err.code === 'ERR_NETWORK') {
                dispatch({ type: ActionType.ALL_MOSHAVERAN_ERROR, message: 'ERR_NETWORK' })
            } else {
                dispatch({ type: ActionType.ALL_MOSHAVERAN_ERROR, message: err.response.data.error })
            }
        })
    }
}
